import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    vendorNames: [],
    accountStatus: [],
    sources: [],
    hasError: 0,
    isLoading: false,
    selectedVendor: '',
    selectedReport: [],
    reportMetaData: {name: '', fileType: ''},
    reports: [],
    isEmpty: false,
    tableView: false
}


const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {
        setVendors: (state,action) => {
            state.vendorNames = action.payload
        },
        onReportsInit: (state,action) => {
            state.selectedVendor = action.payload.vendorName
            state.isLoading = true
            state.isEmpty = false
        },
        onReportsSuccess: (state, action) => {
            state.reports = action.payload
            state.hasError = 0
            state.isLoading = false
        },
        onReportsFailure: (state, action) => {
            state.isLoading = false
            state.hasError = action.payload.errorCode
            state.isEmpty = action.payload.empty
            state.reports = []
        },
        onGettingFilterOptions: (state, action) => {
            state.reports = []
            state.hasError = 0
            state.vendorNames = action.payload.brokers || []
            state.accountStatus = action.payload.account_status || []
            state.sources = action.payload.sources || []
            state.isLoading = false
        },
        toggleTableView: (state,action) => {
            state.tableView = action.payload
        },
        setReportMetaData: (state, action) => {
            state.reportMetaData.name = action.payload.name
            state.reportMetaData.fileType = action.payload.fileType
        },
        toggleLoading: (state, action) => {
            state.isLoading = action.payload
        },
        resetReport: (state) => {
            state.isLoading =  false
            state.selectedVendor =  ''
            state.reports = []
            state.isEmpty = false
        },
        resetAllReportInfo: (state) => {
            state.vendorNames =  []
            state.hasError =  0
            state.isLoading =  false
            state.selectedVendor =  ''
            state.selectedVendor =  ''
            state.reportMetaData =  {name: '', fileType: ''}
            state.reports = []
            state.selectedReport = []
            state.tableView = false
            state.isEmpty = false
        }
    }
})

export const { setVendors, setReport, onReportsInit, onReportsSuccess, onReportsFailure, toggleTableView, setReportMetaData, toggleLoading, resetAllReportInfo, onGettingFilterOptions, resetReport } = reportsSlice.actions
export default reportsSlice.reducer